import { format } from 'date-fns'

// Returns in format `26 MAR 1984`
export function formatAsDocumentDate(date: Date): string {
  return format(date, 'dd MMM yyyy').toUpperCase()
}
